import PersonIcon from "@mui/icons-material/Person";

export default function DraggingItem({
  isDragging,
  position,
  dragId,
  avatarImages,
}) {
  return (
    isDragging &&
    position && (
      <div
        style={{
          position: "absolute",
          left: position.x + 10,
          top: position.y - 25,
          width: 50,
          height: 50,
          touchAction: "none", // evita el scroll del navegador al mover el dedo
          zIndex: 1000,
          // display: isDragging ? "block" : "none",
          display: "flex",
          flexDirection: "row",
          fontSize: 20,
          alignItems: "center",
          whiteSpace: "nowrap",
        }}
      >
        {dragId.img > 0 ? (
          <div style={{ position: "relative" }}>
            <img
              src={avatarImages["ani" + dragId.img].svg}
              alt="avatar"
              style={{ width: 40 }}
            />
          </div>
        ) : (
          <PersonIcon style={{ fontSize: 40, color: "gray" }} />
        )}
        {dragId.name}
      </div>
    )
  );
}
